import { Component } from '@angular/core';

@Component({
    selector: 'app-hero',
    imports: [],
    templateUrl: './hero.component.html'
})
export class HeroComponent {

}
